import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import SliderImage from '../SliderImage';

import generalStyles from './style/general.module.css';

const cx = classNames.bind({ ...generalStyles });

export default function MediaImageSliderRow({ images, isReversed }) {
  const innerClassName = cx({
    inner: !isReversed,
    innerReversed: isReversed,
  });

  return (
    <div className={cx('row')}>
      <div className={innerClassName}>
        {images.map(item => (
          <SliderImage alt={item.alt} key={item.id} src={item.src} />
        ))}
        {images.map(item => (
          <SliderImage alt={item.alt} key={item.id} src={item.src} />
        ))}
      </div>
    </div>
  );
}

MediaImageSliderRow.propTypes = {
  images: PropTypes.array.isRequired,
  isReversed: PropTypes.bool,
};

MediaImageSliderRow.defaultProps = {
  isReversed: false,
};



// WEBPACK FOOTER //
// ./src/components/modules/Media/MediaImageSlider/MediaImageSliderRow/index.js